<template>
    <left-sidebar-layout class="product-page">
        <secondary-nav-menu
            :items="categories"
            :selected="product.category.text"
            class="d-lg-none"
            slot="mobile-sidebar"
            v-test:mobileSecondaryNavMenu
        />

        <template slot="desktop-sidebar">
            <b-button
                class="back-btn"
                variant="light"
                :to="product.category.to"
                v-test:backBtnSidebar
            >
                <app-icon name="chevron-left" />
                <span>{{ $snippet('back') }}</span>
            </b-button>

            <secondary-nav-menu
                :items="categories"
                :selected="product.category.text"
                v-test:desktopSecondaryNavMenu
            />
        </template>

        <template slot="primary-content">
            <b-button
                class="back-btn d-lg-none"
                variant="outline-primary"
                size="sm"
                :to="product.category.to"
                v-test:backBtnPrimary
            >
                <app-icon name="chevron-left" />
                <span>{{ $snippet('back') }}</span>
            </b-button>

            <bread-crumbs
                :crumbs="breadcrumbs"
                class="d-none d-lg-block"
            />

            <product-details
                :name="product.name"
                :description="product.description"
                :calories="product.calories"
                :weight="product.weight"
                :image="product.image"
                :image-sm="product.imageSm"
                :dietary-labels="product.dietaryLabels"
                :product-type="type"
                :contains="product.contains"
                :allergen-warning="product.allergenWarning"
                :may-contain="product.mayContain"
                :nutrition-text="product.nutritionText"
                :nutrition-facts="product.nutritionFacts"
                :plant-points="product.plantPoints"
                :ingredients="product.ingredients"
                :ingredients-disclaimer="product.ingredientsDisclaimer"
                :story-title="product.storyTitle"
                :story-content="product.storyContent"
                :how-to-enjoy-title="product.howToEnjoyTitle"
                :how-to-enjoy-content="product.howToEnjoyContent"
                :hero-button-link="product.heroButtonLink"
                :hero-button-text="product.heroButtonText"
                :retailers="product.retailers"
                :pdf-button-link="product.pdfButtonLink"
                :pdf-button-text="product.pdfButtonText"
                :show-soy-sauce-modal-button="product.showSoySauceModalButton"
            />

            <aside
                v-if="related.items && related.items.length"
                class="related"
                aria-label="Related items"
                v-test:relatedAside
            >
                <item-card-section
                    :title="related.title"
                    :items="related.items"
                />
            </aside>

            <read-more
                v-if="product.readMore.buttonText && product.readMore.content"
                :button-text="product.readMore.buttonText"
                :content="product.readMore.content"
            />
        </template>
    </left-sidebar-layout>
</template>

<script>
    import LeftSidebarLayout from '../LeftSidebarLayout/LeftSidebarLayout';
    import BreadCrumbs from '../../atoms/BreadCrumbs/BreadCrumbs';
    import SecondaryNavMenu from '../../molecules/SecondaryNavMenu/SecondaryNavMenu';
    import ProductDetails from '../ProductDetails/ProductDetails';
    import ItemCardSection from '../ItemCardSection/ItemCardSection';
    import ReadMore from '../../molecules/ReadMore/ReadMore';

    export default {
        name: 'product-page',

        components: { LeftSidebarLayout, SecondaryNavMenu, ProductDetails, BreadCrumbs, ItemCardSection, ReadMore },

        props: {
            product: {
                type: Object,
                default: () => ({}),
            },

            breadcrumbs: {
                type: Array,
                default: () => ([]),
            },

            related: {
                type: Object,
                default: () => ({}),
            },

            categories: {
                type: Array,
                default: () => ([]),
            },

            type: {
                type: String,
                default: 'grocery',
                validator: (val) => ['grocery', 'product'].includes(val),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .back-btn {
        position: absolute;
        left: -8px;
        top: -3px;
        min-width: 75px;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        align-items: center;
        font-weight: 400;
        z-index: 1;

        @include media-breakpoint-up(sm) {
            left: 0;
        }

        @include media-breakpoint-up(lg) {
            left: auto;
            right: 30px;
            top: 0;
            min-width: 110px;
            justify-content: space-between;
            color: $itsu-primary;
            padding-right: 15px;
        }

        @include media-breakpoint-up(xl) {
            right: 0;
        }

        &:focus {
            @include media-breakpoint-up(lg) {
                color: $white;
            }
        }

        .app-icon {
            position: relative;
            top: -1px;
            margin-right: 5px;
        }
    }

    .category-name {
        font-size: rem(24px);
        line-height: rem(28px);
        font-weight: 700;
    }

    .secondary-nav-menu {
        margin-bottom: 10px;
        max-width: fit-content;
        margin-left: auto;
        margin-right: auto;
        @include media-breakpoint-up(lg) {
            max-width: unset;
        }
    }

    .bread-crumbs {
        margin-bottom: 10px;
    }

    .related {
        margin-top: -2px;
        border-top: 2px solid secondary-palette(5);
    }

    .read-more {
        margin-top: 25px;
    }
</style>
